// frontend/src/pages/SubscriptionCancel.js - REDESIGNED VERSION
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useLanguage } from '../contexts/LanguageContext';

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    toast(t('subscriptionCancel.toast', 'Manage your subscription from our plans page'), {
      icon: '📋',
      duration: 3000,
    });

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/pricing');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, t]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4 py-12">
      <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl text-center max-w-md w-full border border-gray-100">
        {/* Icon */}
        <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center shadow-lg shadow-blue-100/50">
          <svg
            className="w-10 h-10 text-blue-600"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
          </svg>
        </div>

        {/* Text Content */}
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
          {t('subscriptionCancel.title', 'Subscription Management')}
        </h1>

        <p className="text-gray-600 mb-6">
          {t('subscriptionCancel.description', 'All subscription options are available on our plans page. You can view, upgrade, or cancel your subscription from there.')}
        </p>

        {/* Countdown */}
        <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-100">
          <div className="text-4xl font-bold text-gray-800 mb-2">
            {countdown}
          </div>
          <p className="text-gray-600">
            {t('subscriptionCancel.countdown.label', 'Redirecting in')} {countdown} {t('subscriptionCancel.countdown.seconds', 'second' + (countdown !== 1 ? 's' : ''))}
          </p>
        </div>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/pricing')}
            className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-300 transform hover:scale-[1.02] shadow-lg shadow-blue-500/25"
          >
            {t('subscriptionCancel.buttons.goToPlans', 'Go to Plans Page')}
          </button>

          <button
            onClick={() => navigate(-1)}
            className="w-full py-3 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors duration-300"
          >
            {t('subscriptionCancel.buttons.goBack', 'Go Back')}
          </button>
        </div>

        {/* Note */}
        <div className="mt-6 pt-6 border-t border-gray-100">
          <p className="text-xs text-gray-500">
            {t('subscriptionCancel.note', 'You will be redirected automatically, or click any button above')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;